import CartReview from './CartReview';

export default CartReview;
